import { Component, OnInit } from '@angular/core';
@Component({
    selector: 'app-data-loader',
    templateUrl: './app-data-loader.component.html',
    styleUrls: ['./app-data-loader.component.scss']
})
export class AppDataLoaderComponent implements OnInit {

    ngOnInit() {

    }

}
